import { CATALOGO } from '@/constants/catalogo';

/**
 * Formatear MXN
 */
export const fmt = (n) =>
  new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(n || 0);

/**
 * Determinar la submarca emisora según los productos seleccionados.
 * Si todos los productos son de la misma submarca → esa submarca.
 * Si hay mezcla → Group.
 */
export const determinarSubmarca = (productos) => {
  if (!productos || productos.length === 0) return 'group';
  const submarcas = [
    ...new Set(productos.map((p) => CATALOGO[p.id]?.submarca).filter(Boolean)),
  ];
  if (submarcas.length === 1) return submarcas[0];
  return 'group';
};

/**
 * Generar token público para compartir propuesta con cliente.
 * En producción esto debe firmarlo el backend con JWT corto-vivido.
 */
export const generatePublicToken = () => {
  const arr = new Uint8Array(16);
  crypto.getRandomValues(arr);
  return Array.from(arr)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
};

/**
 * Clonar profundo objetos (sin Date issues)
 */
export const deepClone = (obj) => JSON.parse(JSON.stringify(obj));
